<app-widget-home-core
  [widget]="widget"
  [isStoreView]="isStoreView"
  [subheader]="local"
  (click)="onClickWidget()"
>

  <ion-list class="widget-data-list">

    @if (loadedData || isStoreView) {

      @for (item of widgetData | slice: -3; track item.id) {

        <app-clock-in-item
          class="yu-item"
          [item]="item"
        ></app-clock-in-item>

      } @empty {

        <app-empty-item
          [detailEmpty]="true"
          [title]="'WIDGETS.HOME.RRHH.NO_CLOCK_INS' | translate"
        ></app-empty-item>

      }

    } @else {

      <ion-skeleton-text animated></ion-skeleton-text>

    }

  </ion-list>

</app-widget-home-core>
